import type { ReactNode } from 'react'
import { EmptyState } from '@/components/ui/EmptyState'
import { Button } from '@/components/ui/Button'

/** Unified loading / error banners for list & detail pages. */
export function PageLoading({ label = 'Đang tải…' }: { label?: string }) {
  return (
    <p className="px-1 py-8 text-center text-sm text-[var(--color-text-muted)]">
      {label}
    </p>
  )
}

export function PageError({
  message,
  onRetry,
}: {
  message: string
  onRetry?: () => void
}) {
  return (
    <div className="mb-3 rounded-[var(--radius-md)] border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>{message}</span>
        {onRetry ? (
          <Button size="sm" variant="secondary" onClick={onRetry}>
            Thử lại
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export function PageNotFound({
  title,
  description,
  action,
}: {
  title: string
  description?: string
  action?: ReactNode
}) {
  return <EmptyState title={title} description={description} action={action} />
}
